import React from "react";
import { InfiniteData } from "@tanstack/react-query";

import { Animated, RefreshControl, View } from "react-native";
import Loading from "components/Loading";

import { useRecoilValue } from "recoil";
import { AxiosResponse } from "axios";

import { authAtom } from "stores";
import { useFlag } from "hooks";
import css from "styles";

interface InfinityListProps {
  translate?: Animated.AnimatedInterpolation<string | number>;
  responseData?: InfiniteData<AxiosResponse<any, any>>;
  hasNextPage?: boolean;
  isFetchingNextPage?: boolean;
  fetchNextPage?: () => void;
  renderItemList: (items: []) => JSX.Element | JSX.Element[];
  paddingBottom?: number;
  paddingTop?: number;
  onRefresh?: () => Promise<any>;
}

export default function AnimatedInfinityList(props: InfinityListProps) {
  const {
    onRefresh,
    responseData,
    hasNextPage,
    fetchNextPage,
    translate = new Animated.Value(0),
    isFetchingNextPage,
    renderItemList,
    paddingBottom,
    paddingTop,
  } = props;

  const {
    company: { color },
  } = useRecoilValue(authAtom);

  const { flg: refresh, on: startRefresh, off: stopRefresh } = useFlag();
  const _onRefresh = () => {
    startRefresh();
    onRefresh && onRefresh().then(stopRefresh);
  };

  return (
    <Animated.FlatList
      nestedScrollEnabled
      keyboardShouldPersistTaps={"handled"}
      refreshControl={
        <RefreshControl
          colors={[color]}
          refreshing={refresh}
          onRefresh={_onRefresh}
        />
      }
      style={{ transform: [{ translateX: translate }], width: "100%" }}
      contentContainerStyle={{
        ...(paddingTop && { paddingTop }),
        ...(paddingBottom && { paddingBottom }),
        ...css.growContainer,
        ...css.paddingH,
      }}
      showsVerticalScrollIndicator={false}
      data={responseData?.pages?.length ? responseData?.pages : null}
      renderItem={({ item }) => <>{renderItemList(item?.data?.data)}</>}
      keyExtractor={(_, key) => String(key)}
      onEndReached={() => {
        hasNextPage && fetchNextPage && fetchNextPage();
      }}
      onEndReachedThreshold={0.1}
      ListFooterComponent={
        isFetchingNextPage ? (
          <View style={{ paddingVertical: 20 }}>
            <Loading />
          </View>
        ) : (
          <></>
        )
      }
    />
  );
}
